// social media links

export const companyLinkedin = 'https://www.linkedin.com/company/fort-investech/'

export const sidLinkedin = 'https://www.linkedin.com/in/siddharth-goyal-5680785b/'

export const shivaniLinkedin = 'https://www.linkedin.com/in/shivani-goyal-b825217/'

export const companyTwitter = 'https://twitter.com/fortinvestech1'

export const companyInstagram = 'https://instagram.com/fortinvestechsystem'

